import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase-config";
import { doc, getDoc } from "firebase/firestore";
import { Navigate } from "react-router-dom";

export function ProtectedAffiliateRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists() && snap.data().role !== "admin") {
          setAllowed(true);
        } else {
          setAllowed(false);
        }
      } else {
        setAllowed(false);
      }
      setChecking(false);
    });
    return () => unsub();
  }, []);

  if (checking) return null;
  return allowed ? children : <Navigate to="/" replace />;
}

export function ProtectedAdminRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {

        console.log('[ADMIN ROUTE] user.uid:', user.uid);
        console.log('[ADMIN ROUTE] user.email:', user.email);
        const docRef = doc(db, "users", user.uid);
        const snap = await getDoc(docRef);
        console.log('[ADMIN ROUTE] Firestore doc id:', user.uid);
        if (snap.exists()) {
          console.log('[ADMIN ROUTE] Firestore doc data:', snap.data());
        } else {
          console.log('[ADMIN ROUTE] NINCS Firestore doc!');
        }
        if (snap.exists() && (snap.data().role === "admin" || snap.data().role === "super_admin")) {
          setAllowed(true);
        } else {
          setAllowed(false);
        }
      } else {
        setAllowed(false);
      }
      setChecking(false);
    });
    return () => unsub();
  }, []);

  if (checking) return null;
  return allowed ? children : <Navigate to="/" replace />;
}

